import { MainTableFilterOperand } from 'src/app/shared/main-table-module/main-table/main-table-column-filter/main-table-column-filter.component';
import {
  MainTableFilterModel,
  MainTableFilterSearchByModel,
} from 'src/app/shared/models/main-table-filter.model';

export function mergeDueListResponsibleFilters(
  filter: MainTableFilterModel | undefined,
  columnToKeyMap: Record<string, string>
): MainTableFilterModel | undefined {
  if (!filter?.searchBy) {
    return filter;
  }

  const responsibleFilters = filter.searchBy.filter(
    (item): item is MainTableFilterSearchByModel & { value: (string | boolean)[] } =>
      columnToKeyMap[item.property] === 'Responsibles' &&
      item.operand === MainTableFilterOperand.In &&
      Array.isArray(item.value)
  );

  if (responsibleFilters.length < 2) {
    return filter;
  }

  // Every Responsible section maps to the same API field, so send one union of its values.
  const value = [...new Set(responsibleFilters.flatMap((item) => item.value))];

  return {
    ...filter,
    searchBy: [
      ...filter.searchBy.filter((item) => !responsibleFilters.some((entry) => entry === item)),
      { ...responsibleFilters[0], value },
    ],
  };
}
